module.exports = __webpack_public_path__ + "static/media/airbnb-big.a753a340.svg";